import { Points, PointMaterial, Point } from "@react-three/drei";
import { Annotation } from "@/components/annotation";
import { Track } from "../types";
import { Vector3 } from "@react-three/fiber";

interface SelectedPointProps {
  track: Track;
  selectedIndex: number;
  distanceFactor?: number;
  pointPopupContent?: (pointIndex: number) => React.ReactNode;
  pointSize?: number;
}

export function SelectedPoint({
  track,
  selectedIndex,
  distanceFactor,
  pointPopupContent,
  pointSize,
}: SelectedPointProps) {
  const position = [
    track.pose_x[selectedIndex],
    track.pose_z[selectedIndex],
    -track.pose_y[selectedIndex],
  ] as Vector3;

  return (
    <>
      <>
        <Points limit={1} range={1}>
          <PointMaterial
            transparent
            vertexColors
            color="green"
            size={pointSize}
          />
          <Point position={position} />
        </Points>
        <Annotation
          transform={false}
          distanceFactor={distanceFactor}
          position={position}
          zIndexRange={[100, 0]}
        >
          <div className="text-base bg-white font-bold shadow-lg p-2 rounded-lg translate-x-[60%] translate-y-[60%]">
            {pointPopupContent ? (
              pointPopupContent(selectedIndex)
            ) : (
              <ul>
                <li className="whitespace-nowrap">
                  X: {track.pose_x[selectedIndex]}
                </li>
                <li className="whitespace-nowrap">
                  Y: {track.pose_z[selectedIndex]}
                </li>
                <li className="whitespace-nowrap">
                  Z: {-track.pose_y[selectedIndex]}
                </li>
              </ul>
            )}
          </div>
        </Annotation>
      </>
    </>
  );
}
